
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_modal.mustache";
const TPL = handlebars_family.addTemplate("mealplanner/modal_pickmealtype",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"modal V4\"><div class=\"title\"><icon class=\"modal-close\" data-fw-onclick=\"modalclose\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":122},"end":{"line":1,"column":144}}}))
    + "</icon> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"mp.planas",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":152},"end":{"line":1,"column":174}}})) != null ? stack1 : "")
    + " </div><div class=\"content\"> "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"columns") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":203},"end":{"line":1,"column":551}}})) != null ? stack1 : "")
    + " </div></div> ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"display") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":221},"end":{"line":1,"column":541}}})) != null ? stack1 : "")
    + " ";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"flexrow\" data-type=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"type") : depth0), depth0))
    + "\" style=\"cursor:pointer;margin-top:8px;height:64px;padding:16px;border:var(--border);border-radius:8px;overflow:hidden\"><emoji style=\"font-size:32px\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"emoji") : depth0), depth0))
    + "</emoji><flexauto style=\"margin-left:16px;font-weight:500\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"displayName") : depth0), depth0))
    + "</flexauto></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_modal"),depth0,{"name":"layout/layout_modal","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;